// ToggleSwitch.js
import React from 'react';
import css from './HeaderExtra.module.css'
import { useStaffMode } from '../../../hooks/StaffModeProvider';
interface ToggleSwitchProps {
  IsStaffNavigate?: boolean;
  onToggle: () => void;


}


const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ IsStaffNavigate, onToggle }) => {
  const navigationClassName = (!IsStaffNavigate ? `bg-primary-dark` : `bg-secondary-dark`);
  const { toggleStaffMode } = useStaffMode()

  const handleToggleStaffMode = () => {
    toggleStaffMode()
    onToggle()
  }
  return (
    <div className="md:order-3 flex h-full items-center ">
      <label htmlFor="toggleA" className="flex cursor-pointer md:py-0 py-4">
        <div className="relative">
          <input type="checkbox" id="toggleA" className="sr-only" checked={IsStaffNavigate} onChange={handleToggleStaffMode} />
          <div className={`block ${navigationClassName} w-10 h-6 rounded-full`}></div>
          <div className="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
        </div>
        <div className={`ml-4 text-lg text-gray-font roboto_font `}>
          Staff Mode
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;